import styled from "styled-components";

const ThankYouModalImageContainer = styled.div`
    text-align: center;
    width: 100%;
`;

export const ThankYouModalImage = () => (
    <ThankYouModalImageContainer>
        <svg
            width="249"
            height="180"
            viewBox="0 0 249 180"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g
                opacity="0.3"
                filter="url(#filter0_f)"
            >
                <rect
                    x="82.4502"
                    y="81.8486"
                    width="84.7332"
                    height="42.772"
                    fill="#195AFE"
                />
            </g>
            <path
                d="M116.43 76.4207L112.476 94.3509"
                stroke="url(#paint0_linear)"
                strokeWidth="2.17335"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M124.249 76.4202L128.204 94.3504"
                stroke="url(#paint1_linear)"
                strokeWidth="2.17335"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M151.963 32.6707C151.963 15.73 137.993 2 120.76 2C103.527 2 89.5537 15.73 89.5537 32.6707C89.5537 47.1636 101.741 62.3272 114.375 72.573H127.142C139.776 62.3272 151.963 47.1604 151.963 32.6707Z"
                fill="url(#paint2_linear)"
            />
            <path
                d="M122.82 2.07043C122.138 2.02592 121.452 2.00049 120.76 2.00049C120.068 2.00049 119.379 2.02592 118.696 2.07043C115.85 6.48283 111.71 16.4107 111.71 33.291C111.71 52.3394 117.157 67.2233 119.68 72.5703H121.834C124.36 67.2201 129.804 52.3394 129.804 33.291C129.807 16.4107 125.667 6.48283 122.82 2.07043Z"
                fill="url(#paint3_linear)"
            />
            <path
                d="M115.074 2.50952C112.767 2.92597 110.549 3.59355 108.446 4.48048C102.155 10.0818 95.7217 20.0542 95.7217 33.4981C95.7217 52.2381 112.121 68.6256 116.891 72.5707H117.338C110.422 63.2468 102.886 46.4905 102.886 32.2551C102.889 18.3535 111.111 5.93962 115.074 2.50952Z"
                fill="url(#paint4_linear)"
            />
            <path
                d="M145.794 33.4981C145.794 20.0542 139.364 10.0818 133.07 4.48048C130.97 3.59355 128.752 2.92597 126.442 2.50952C130.404 5.93962 138.626 18.3535 138.626 32.2551C138.626 46.4905 131.09 63.2468 124.175 72.5707H124.621C129.392 68.6256 145.794 52.2413 145.794 33.4981Z"
                fill="url(#paint5_linear)"
            />
            <path
                d="M127.963 76.8585H112.714C112.342 76.8585 112.041 76.4961 112.041 76.0478V73.3839C112.041 72.9356 112.342 72.5732 112.714 72.5732H127.963C128.335 72.5732 128.636 72.9356 128.636 73.3839V76.0478C128.639 76.4961 128.335 76.8585 127.963 76.8585Z"
                fill="url(#paint6_linear)"
            />
            <path
                d="M147.978 95.8939L95.5701 91.079C94.3493 90.9679 93.2664 91.8478 93.1534 93.0477L89.5633 130.8C89.4503 132 90.3455 133.064 91.5663 133.175L143.977 137.99C145.197 138.101 146.28 137.222 146.393 136.022L149.983 98.2692C150.096 97.0693 149.199 96.005 147.978 95.8939Z"
                fill="url(#paint7_linear)"
            />
            <path
                d="M119.696 115.309L149.506 96.7224C149.142 96.2691 148.606 95.9492 147.975 95.8914L95.5674 91.0787C95.0158 91.0276 94.5071 91.2009 94.0889 91.4942L119.696 115.309Z"
                fill="white"
            />
            <ellipse
                cx="119.771"
                cy="115.31"
                rx="8.68888"
                ry="8.53975"
                fill="url(#paint8_linear)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M121.669 111.153C121.584 111.124 121.497 111.094 121.407 111.068C119.965 110.649 119.163 111.336 118.95 112.046C118.658 113.015 119.156 113.678 120.445 114.655C122.027 115.852 122.681 116.964 122.222 118.488C122.087 118.939 121.861 119.344 121.551 119.679C122.828 119.167 123.868 118.109 124.29 116.706C124.972 114.444 123.812 112.077 121.669 111.153Z"
                fill="white"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M119.424 115.548C117.883 114.448 117.082 113.259 117.521 111.798C117.587 111.582 117.674 111.38 117.782 111.194C116.6 111.735 115.651 112.753 115.252 114.079C114.835 115.463 115.107 116.885 115.871 117.994C116.399 118.627 116.909 119.103 117.945 119.384C119.347 119.765 120.478 119.236 120.793 118.189C121.085 117.22 120.688 116.502 119.424 115.548Z"
                fill="white"
            />
            <g filter="url(#filter1_d)">
                <path
                    d="M87.8535 70.6101H85.8296V66.6733C85.8296 60.5928 80.8121 55.6614 74.6254 55.6614C70.363 55.6614 66.6602 58.0009 64.7666 61.4405C63.2756 60.0917 61.29 59.2667 59.1051 59.2667C54.8005 59.2667 51.2587 62.4614 50.7949 66.5678H47.9239C42.4426 66.5715 38 70.9379 38 76.3214C38 81.7086 42.4426 86.075 47.9239 86.075H71.2216H74.6292H87.8573C92.2041 86.075 95.7229 82.6128 95.7229 78.3444C95.7229 74.0761 92.1964 70.6101 87.8535 70.6101Z"
                    fill="white"
                />
            </g>
            <g opacity="0.5">
                <path
                    d="M177.38 96.3664L177.041 103.606"
                    stroke="url(#paint9_linear)"
                    strokeWidth="1.35834"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M179.851 96.0596L182.011 102.989"
                    stroke="url(#paint10_linear)"
                    strokeWidth="1.35834"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <path
                d="M193.179 69.5088C191.96 60.02 183.147 53.3009 173.494 54.4991C163.841 55.6974 157.003 64.3594 158.222 73.8483C159.266 81.9661 167.184 89.6122 174.998 94.4726L182.148 93.5849C188.487 86.9676 194.222 77.6249 193.179 69.5088Z"
                fill="url(#paint11_linear)"
            />
            <g opacity="0.4">
                <path
                    d="M174.656 54.3948C174.271 54.4173 173.885 54.4508 173.497 54.4989C173.109 54.547 172.725 54.6092 172.346 54.6816C171.069 57.351 169.465 63.1997 170.68 72.6547C172.051 83.3241 176.173 91.2822 177.972 94.1018L179.178 93.952C180.208 90.7796 182.186 82.066 180.815 71.3966C179.602 61.9414 176.568 56.6684 174.656 54.3948Z"
                    fill="url(#paint12_linear)"
                />
                <path
                    d="M170.348 55.1798C169.086 55.5734 167.892 56.1016 166.778 56.7446C163.657 60.3195 160.772 66.3526 161.739 73.8828C163.088 84.3795 173.453 92.4183 176.41 94.2963L176.66 94.2653C172.115 89.5236 166.688 80.662 165.663 72.6884C164.664 64.9016 168.376 57.3766 170.348 55.1798Z"
                    fill="url(#paint13_linear)"
                />
                <path
                    d="M189.784 70.4008C188.817 62.8706 184.497 57.7319 180.568 55.0321C179.329 54.6813 178.038 54.4617 176.714 54.389C179.181 56.0348 184.68 62.4163 185.68 70.2029C186.705 78.1765 183.69 88.0861 180.487 93.7895L180.737 93.7585C183.126 91.217 191.134 80.8993 189.784 70.4008Z"
                    fill="url(#paint14_linear)"
                />
            </g>
            <path
                d="M182.917 95.9282L174.376 96.9885C174.167 97.0144 173.973 96.8323 173.941 96.5812L173.749 95.0891C173.717 94.838 173.859 94.6141 174.067 94.5882L182.609 93.5279C182.817 93.502 183.012 93.6841 183.044 93.9352L183.236 95.4273C183.27 95.6782 183.126 95.9023 182.917 95.9282Z"
                fill="url(#paint15_linear)"
            />
            <path
                d="M174.361 103.382C174.189 102.745 174.618 102.106 175.272 102.024L183.321 101.025C183.975 100.944 184.553 101.459 184.547 102.118L184.495 107.76C184.49 108.302 184.085 108.756 183.547 108.823L177.027 109.632C176.488 109.699 175.981 109.358 175.839 108.834L174.361 103.382Z"
                fill="url(#paint16_linear)"
            />
            <g filter="url(#filter2_d)">
                <path
                    d="M162.309 33.27H162.196V31.7259C162.196 27.3757 158.608 23.8489 154.182 23.8489C150.142 23.8489 146.801 26.7875 146.25 30.6083H142.973C138.876 30.6083 135.552 33.8729 135.552 37.9021C135.552 41.9288 138.873 45.1958 142.973 45.1958H162.309C165.658 45.1958 168.376 42.5268 168.376 39.2329C168.376 35.9389 165.66 33.27 162.309 33.27Z"
                    fill="white"
                />
            </g>
            <path
                opacity="0.2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M140.721 59.05C114.185 60.319 98.515 40.2485 90.624 24.677C89.926 27.2253 89.5537 29.905 89.5537 32.6701C89.5537 47.163 101.741 62.3267 114.375 72.5725H127.142C131.948 68.6745 136.69 64.0643 140.721 59.05Z"
                fill="#195AFE"
            />
            <defs>
                <filter
                    id="filter0_f"
                    x="0.94973"
                    y="0.348167"
                    width="247.734"
                    height="205.773"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="40.7502"
                        result="effect1_foregroundBlur"
                    />
                </filter>
                <filter
                    id="filter1_d"
                    x="27.1333"
                    y="44.7946"
                    width="79.4563"
                    height="52.1471"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5.43336" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.2 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_d"
                    x="124.685"
                    y="12.9821"
                    width="54.5575"
                    height="43.0804"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood
                        floodOpacity="0"
                        result="BackgroundImageFix"
                    />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset />
                    <feGaussianBlur stdDeviation="5.43336" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.129412 0 0 0 0 0.376471 0 0 0 0 0.980392 0 0 0 0.2 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow"
                        result="shape"
                    />
                </filter>
                <linearGradient
                    id="paint0_linear"
                    x1="114.453"
                    y1="76.4207"
                    x2="114.453"
                    y2="94.3509"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#195AFE" />
                    <stop
                        offset="1"
                        stopColor="#9AB6FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint1_linear"
                    x1="126.227"
                    y1="76.4202"
                    x2="126.227"
                    y2="94.3504"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#195AFE" />
                    <stop
                        offset="1"
                        stopColor="#9AB6FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint2_linear"
                    x1="109.473"
                    y1="70.718"
                    x2="144.304"
                    y2="8.62769"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#195AFE" />
                    <stop
                        offset="1"
                        stopColor="#AEC5FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint3_linear"
                    x1="120.757"
                    y1="2.00049"
                    x2="120.757"
                    y2="72.5703"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint4_linear"
                    x1="106.53"
                    y1="2.50952"
                    x2="106.53"
                    y2="72.5707"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint5_linear"
                    x1="134.984"
                    y1="2.50952"
                    x2="134.984"
                    y2="72.5707"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint6_linear"
                    x1="112.682"
                    y1="76.8585"
                    x2="127.939"
                    y2="73.8562"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9AB6FB" />
                    <stop
                        offset="0.913211"
                        stopColor="white"
                    />
                </linearGradient>
                <linearGradient
                    id="paint7_linear"
                    x1="125.063"
                    y1="91.0696"
                    x2="119.95"
                    y2="127.716"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DCE6FF" />
                    <stop
                        offset="1"
                        stopColor="white"
                    />
                </linearGradient>
                <linearGradient
                    id="paint8_linear"
                    x1="119.771"
                    y1="106.77"
                    x2="119.771"
                    y2="123.85"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF7A1A" />
                    <stop
                        offset="1"
                        stopColor="#FFC100"
                    />
                </linearGradient>
                <linearGradient
                    id="paint9_linear"
                    x1="176.755"
                    y1="96.444"
                    x2="177.635"
                    y2="103.532"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#195AFE" />
                    <stop
                        offset="1"
                        stopColor="#9AB6FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint10_linear"
                    x1="180.476"
                    y1="95.9821"
                    x2="181.356"
                    y2="103.07"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#195AFE" />
                    <stop
                        offset="1"
                        stopColor="#9AB6FF"
                    />
                </linearGradient>
                <linearGradient
                    id="paint11_linear"
                    x1="172.118"
                    y1="93.7745"
                    x2="187.259"
                    y2="56.6154"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#FF7A1A" />
                    <stop
                        offset="1"
                        stopColor="#FEB72B"
                    />
                </linearGradient>
                <linearGradient
                    id="paint12_linear"
                    x1="173.495"
                    y1="54.4991"
                    x2="178.405"
                    y2="94.048"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint13_linear"
                    x1="165.563"
                    y1="55.7739"
                    x2="170.437"
                    y2="95.0377"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint14_linear"
                    x1="181.499"
                    y1="53.795"
                    x2="186.373"
                    y2="93.0589"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop
                        offset="1"
                        stopColor="white"
                        stopOpacity="0"
                    />
                </linearGradient>
                <linearGradient
                    id="paint15_linear"
                    x1="174.358"
                    y1="96.9907"
                    x2="182.677"
                    y2="94.2167"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9AB6FB" />
                    <stop
                        offset="0.913211"
                        stopColor="white"
                    />
                </linearGradient>
                <linearGradient
                    id="paint16_linear"
                    x1="176.022"
                    y1="109.757"
                    x2="181.628"
                    y2="100.313"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#195AFE" />
                    <stop
                        offset="1"
                        stopColor="#9FBAFD"
                    />
                </linearGradient>
            </defs>
        </svg>
    </ThankYouModalImageContainer>
);
